// theme.js
const theme = {
  colors: {
    primary: "#2B2C2B",
    secondary: "#35CC53",
    neutral: {
      100: "#FFFFFF",
      200: "#F7F7F7",
      300: "#EEEEEE",
      400: "#E1E1E1"
    },
    text: {
      normal: "#2B2C2B",
      alternative: "#6D6F6D",
      assistive: "#9DA09D",
      inverse: "#FFFFFF",
      accent: "#35CC53",
      accentDark: "#24963B",
    },
    status: {
      info: "#007AFF",
      success: "#35CC53",
      warning: "#FF9500",
      error: "#FF4242"
    }

  },
  typography: {
    // Headline
    headline1: { fontSize: 28, lineHeight: 34, fontWeight: { bold: 700, medium: 500 } }, 
    headline2: { fontSize: 22, lineHeight: 28, fontWeight: { bold: 700, medium: 500 } }, 
    headline3: { fontSize: 18, lineHeight: 24, fontWeight: { bold: 700, medium: 500 } }, 
    // Body
    body1: { fontSize: 16, lineHeight: 24, fontWeight: { medium: 500, regular: 400 } },
    body2: { fontSize: 14, lineHeight: 20, fontWeight: { medium: 500, regular: 400 } },
    // Caption 
    caption: { fontSize: 12, lineHeight: 16, fontWeight: { bold: 700, medium: 500, regular: 400 } },
  }
};
export default theme